// noinspection DuplicatedCode
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import Card from "@material-tailwind/react/Card";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import Loading from "../../../../components/loading/Loading";
import Skeltons from "../../../../components/loading/Skeltons";
import { Colors } from "../../../../assets/Colors";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";
import { approve } from "../../../setup/approval/approvalSlice";
import {
  JENIS_BIAYA,
  METODE_PEMBAYARAN,
  MODA_TRANSPORTASI,
  deletePerjalananDinas,
  getIdentitasPerjalananDinas,
  getPerjalananDinas,
  getSpecPerjalananDinas,
  simpanFormBiaya,
  insertPerjalananDinas,
  rupiah,
  tglIndo,
  updatePerjalananDinas,
} from "./perjalananDinasApi";
import { cetakFormBiaya, cetakPertanggungjawaban, cetakSuratPengajuan, cetakSuratTugas } from "./suratTugasPdf";
import {
  deleteLaporan,
  deleteUbah,
  prosesUlangFinance,
  selesaikanSettlement,
  teksSisaLPD,
} from "./perjalananDinasApi";
import { DetailLaporan, DetailUbah, LaporanModal, UbahModal } from "./PerjalananDinasFase2";

const ymd = (d) =>
  d instanceof Date && !isNaN(d.getTime())
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
    : "";
const dariYmd = (s) => (s ? new Date(`${s}T00:00:00`) : "");
const hariIni = () => {
  const t = new Date();
  return new Date(t.getFullYear(), t.getMonth(), t.getDate());
};
// SLA H-3: berangkat minimal 3 hari dari hari ini (sama aturan backend: TanggalMulai < hari ini + 3).
const kurangDariH3 = (mulai) => {
  if (!(mulai instanceof Date) || isNaN(mulai.getTime())) return false;
  const batas = hariIni();
  batas.setDate(batas.getDate() + 3);
  return mulai < batas;
};

const FORM_AWAL = {
  PerjalananDinasID: "",
  Nik: "",
  Kategori: "Penugasan",
  Tujuan: "",
  Keperluan: "",
  Keterangan: "",
};
const BARIS_RINCIAN = { Tanggal: "", Waktu: "", Kegiatan: "", Lokasi: "", Keterangan: "" };

const INPUT =
  "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500";
const LABEL = "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2";

const statusClass = (s) =>
  s === "Selesai"
    ? "bg-green-100 text-green-800"
    : s === "Belum Dikirim"
    ? "bg-gray-100 text-gray-700"
    : s === "Ditolak"
    ? "bg-red-100 text-red-800"
    : "bg-yellow-100 text-yellow-800";

const PerjalananDinasPage = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(FORM_AWAL);
  const [tglMulai, setTglMulai] = useState("");
  const [tglSelesai, setTglSelesai] = useState("");
  const [rincian, setRincian] = useState([{ ...BARIS_RINCIAN }]);
  const [identitas, setIdentitas] = useState(null);
  const [formBiaya, setFormBiaya] = useState({ show: false, pd: null });
  const [coba, setCoba] = useState(false);
  const [saving, setSaving] = useState(false);

  const [detail, setDetail] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  // Fase 2: perubahan agenda & laporan (LPD). target = baris pengajuan induk.
  const [ubahForm, setUbahForm] = useState({ show: false, pd: null, ubah: null });
  const [laporanForm, setLaporanForm] = useState({ show: false, pd: null, laporan: null });
  const [lihatUbah, setLihatUbah] = useState("");

  const muat = useCallback(async (q = "") => {
    setLoading(true);
    try {
      setRows(await getPerjalananDinas(q));
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    muat("");
  }, [muat]);

  const PAGE_SIZE = 10;
  const totalPage = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPage);
  const pageRows = useMemo(() => rows.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE), [rows, safePage]);

  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  // Identitas read-only (Nama / NIK / Jabatan / Departemen) mengikuti karyawan terpilih.
  useEffect(() => {
    if (!form.Nik) {
      setIdentitas(null);
      return;
    }
    let batal = false;
    getIdentitasPerjalananDinas(form.Nik)
      .then((d) => !batal && setIdentitas(d))
      .catch(() => !batal && setIdentitas(null));
    return () => {
      batal = true;
    };
  }, [form.Nik]);

  const bukaForm = (row) => {
    setCoba(false);
    if (row) {
      setForm({
        PerjalananDinasID: row.PerjalananDinasID,
        Nik: row.Nik,
        Kategori: row.Kategori,
        Tujuan: row.Tujuan,
        Keperluan: row.Keperluan,
        Keterangan: row.Keterangan || "",
        NomorSPPD: row.NomorSPPD,
      });
      setTglMulai(dariYmd(row.TanggalMulai));
      setTglSelesai(dariYmd(row.TanggalSelesai));
      setRincian([{ ...BARIS_RINCIAN }]);
      // rincian tugas hanya ada di endpoint detail
      getSpecPerjalananDinas(row.PerjalananDinasID)
        .then((d) => {
          if (d?.Rincian?.length) setRincian(d.Rincian.map((r) => ({ ...r })));
        })
        .catch(() => {});
    } else {
      setForm(FORM_AWAL);
      setTglMulai("");
      setTglSelesai("");
      setRincian([{ ...BARIS_RINCIAN }]);
    }
    setShowForm(true);
  };

  const hari =
    tglMulai instanceof Date && tglSelesai instanceof Date && tglSelesai >= tglMulai
      ? Math.round((tglSelesai - tglMulai) / 86400000) + 1
      : 0;
  const rincianTerisi = rincian.filter((r) => r.Tanggal || r.Waktu || r.Kegiatan.trim() || r.Lokasi || r.Keterangan);
  const setR = (i, k, v) => setRincian((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));

  const simpan = async () => {
    setCoba(true);
    if (!form.Nik || !form.Tujuan.trim() || !form.Keperluan.trim() || !(tglMulai instanceof Date) || !(tglSelesai instanceof Date)) return;
    if (tglSelesai < tglMulai) return;
    if (rincianTerisi.length === 0 || rincianTerisi.some((r) => !r.Tanggal || !r.Kegiatan.trim())) return;
    if (rincianTerisi.some((r) => r.Waktu && !/^\d{2}:\d{2}-\d{2}:\d{2}$/.test(r.Waktu))) {
      toast.error("Waktu pada Rincian Tugas harus lengkap (jam mulai dan jam selesai).", { position: "bottom-right" });
      return;
    }
    const payload = {
      PerjalananDinasID: form.PerjalananDinasID,
      Nik: form.Nik,
      Kategori: form.Kategori,
      Tujuan: form.Tujuan,
      Keperluan: form.Keperluan,
      Keterangan: form.Keterangan,
      TanggalMulai: ymd(tglMulai),
      TanggalSelesai: ymd(tglSelesai),
      Rincian: rincianTerisi,
    };
    setSaving(true);
    try {
      if (form.PerjalananDinasID) await updatePerjalananDinas(payload);
      else await insertPerjalananDinas(payload);
      toast.success(form.PerjalananDinasID ? "Data diperbarui" : "Pengajuan dibuat", {
        position: "bottom-right",
        autoClose: 3000,
      });
      setShowForm(false);
      muat(search);
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setSaving(false);
  };

  const kirim = async (row) => {
    const peringatan = row.TanggalMulai && kurangDariH3(dariYmd(row.TanggalMulai))
      ? "\n\nPerhatian: keberangkatan kurang dari H-3, pengajuan akan ditandai TERLAMBAT."
      : "";
    if (!window.confirm(`Kirim ${row.PerjalananDinasID} untuk approval?${peringatan}`)) return;
    await kirimDokumen(row.PerjalananDinasID);
  };

  // Kirim dokumen apa pun (PD/PU/PL) lewat endpoint approval generik.
  const kirimDokumen = async (id) => {
    try {
      const res = await dispatch(approve({ primary: id })).unwrap();
      if (res && res.data === "Berhasil") {
        toast.success("Dikirim untuk approval", { position: "bottom-right", autoClose: 3000 });
      } else {
        toast.error((res && res.message) || "Gagal mengirim", { position: "bottom-right" });
      }
    } catch (e) {
      toast.error((e && e.message) || "Gagal mengirim untuk approval", { position: "bottom-right" });
    }
    muat(search);
    if (showDetail && detail) bukaDetail(detail);
  };

  const hapus = async (row) => {
    if (!window.confirm(`Hapus pengajuan ${row.PerjalananDinasID} (${row.NamaKaryawan})?`)) return;
    try {
      await deletePerjalananDinas(row.PerjalananDinasID);
      toast.success("Data dihapus", { position: "bottom-right", autoClose: 3000 });
      muat(search);
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
  };

  const bukaDetail = async (row) => {
    setDetail(null);
    setShowDetail(true);
    try {
      setDetail(await getSpecPerjalananDinas(row.PerjalananDinasID));
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
      setShowDetail(false);
    }
  };

  const salahTanggal = coba && tglMulai instanceof Date && tglSelesai instanceof Date && tglSelesai < tglMulai;
  // Kolom Dana & Estimasi hanya untuk user tertentu; server mengosongkan nilainya dan menandai baris dengan LihatDana.
  const lihatDana = rows.some((r) => r.LihatDana);
  const kolom = ["No. SPPD", "Karyawan", "Jenis Dinas", "Kota Tujuan", "Tanggal", ...(lihatDana ? ["Dana", "Estimasi"] : []), "Status", "Aksi"];

  return (
    <>
      <div className="md:ml-64">
        <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto" />
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {loading ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    {rows.some((r) => r.LPDOutstanding) && (
                      <div className="mx-4 mt-4 rounded border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-800">
                        {rows.filter((r) => r.LPDOutstanding).length} laporan perjalanan dinas belum selesai
                        {rows.some((r) => r.LPDOutstanding && r.SisaHariLPD < 0) && (
                          <b className="text-red-600">
                            {" "}
                            — {rows.filter((r) => r.LPDOutstanding && r.SisaHariLPD < 0).length} melewati batas 7 hari kerja
                          </b>
                        )}
                        . Lihat juga menu Monitoring LPD.
                      </div>
                    )}
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <button
                        onClick={() => bukaForm(null)}
                        className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                      >
                        Tambah +
                      </button>
                      <input
                        type="text"
                        placeholder="Cari No. SPPD / ID / NIK / nama / kota (Enter)"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setPage(1);
                            muat(search);
                          }
                        }}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-96"
                      />
                    </div>

                    <div className="overflow-x-auto px-4 pt-4">
                      <table className="table-auto w-full text-sm text-left text-gray-500">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {kolom.map((h) => (
                              <th key={h} className="py-3 px-4">
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td colSpan={kolom.length} className="text-center py-8 text-gray-400">
                                Belum ada pengajuan perjalanan dinas
                              </td>
                            </tr>
                          ) : (
                            pageRows.map((row, i) => {
                              const bisaEdit = ["-1", "-2", "-3"].includes(String(row.Status));
                              return (
                                <tr key={row.PerjalananDinasID} className={i % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                                  <td className="py-4 px-4 font-mono text-xs whitespace-nowrap">
                                    {row.NomorSPPD || <span className="text-gray-400">(terbit saat dikirim)</span>}
                                    <div className="text-gray-400">{row.PerjalananDinasID}</div>
                                  </td>
                                  <td className="py-4 px-4">
                                    {row.NamaKaryawan}
                                    <div className="text-xs text-gray-400">{row.NamaJabatan}</div>
                                  </td>
                                  <td className="py-4 px-4">{row.Kategori}</td>
                                  <td className="py-4 px-4">{row.Tujuan}</td>
                                  <td className="py-4 px-4 whitespace-nowrap">
                                    {tglIndo(row.TanggalMulai)} s/d {tglIndo(row.TanggalSelesai)}
                                    <div className="text-xs text-gray-400">{row.JumlahHari} hari</div>
                                  </td>
                                  {lihatDana && (
                                    <>
                                      <td className="py-4 px-4">
                                        {row.BiayaDiajukan ? (row.JenisDana === "UangMuka" ? "Uang Muka" : "Reimbursement") : "-"}
                                      </td>
                                      <td className="py-4 px-4 whitespace-nowrap">
                                        {row.BiayaDiajukan ? (
                                          rupiah(row.EstimasiBiaya)
                                        ) : String(row.Status) === "99" ? (
                                          <span className="text-amber-600 text-xs font-semibold">Form Biaya belum diisi</span>
                                        ) : (
                                          "-"
                                        )}
                                        {row.Kategori === "Penugasan" && (
                                          <div className="text-xs text-gray-400">+ uang saku {rupiah(row.EstimasiUangSaku)}</div>
                                        )}
                                      </td>
                                    </>
                                  )}
                                  <td className="py-4 px-4">
                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(row.StatusKet)}`}>
                                      {row.StatusKet}
                                    </span>
                                    {row.TerlambatH3 && (
                                      <div className="text-xs font-semibold text-amber-600 mt-1">⚠ Lewat SLA H-3</div>
                                    )}
                                    {String(row.Status) === "99" && (
                                      <div
                                        className={
                                          "text-xs mt-1 " +
                                          (row.LPDOutstanding && row.SisaHariLPD < 0
                                            ? "font-semibold text-red-600"
                                            : row.LPDOutstanding && row.SisaHariLPD <= 2
                                            ? "font-semibold text-amber-600"
                                            : "text-gray-500")
                                        }
                                      >
                                        LPD: {row.LaporanStatusKet}
                                        {row.LPDOutstanding && <> · {teksSisaLPD(row)}</>}
                                      </div>
                                    )}
                                  </td>
                                  <td className="py-4 px-4 whitespace-nowrap">
                                    <div className="flex gap-2">
                                      {bisaEdit && (
                                        <>
                                          <button
                                            onClick={() => bukaForm(row)}
                                            className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-3 border border-gray-400 rounded shadow text-sm"
                                          >
                                            Edit
                                          </button>
                                          <button
                                            onClick={() => kirim(row)}
                                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded shadow text-sm"
                                          >
                                            Kirim
                                          </button>
                                        </>
                                      )}
                                      {String(row.Status) === "-1" && (
                                        <button
                                          onClick={() => hapus(row)}
                                          className="bg-white hover:bg-red-50 text-red-600 font-semibold py-1 px-3 border border-red-300 rounded shadow text-sm"
                                        >
                                          Hapus
                                        </button>
                                      )}
                                      {String(row.Status) === "99" && (
                                        <>
                                          {!row.BiayaDiajukan && !row.LaporanID && (
                                            <button
                                              onClick={() => setFormBiaya({ show: true, pd: row })}
                                              className="bg-white hover:bg-blue-50 text-blue-700 font-semibold py-1 px-3 border border-blue-300 rounded shadow text-sm"
                                            >
                                              Form Biaya
                                            </button>
                                          )}
                                          <button
                                            onClick={() => setUbahForm({ show: true, pd: row, ubah: null })}
                                            className="bg-white hover:bg-amber-50 text-amber-700 font-semibold py-1 px-3 border border-amber-300 rounded shadow text-sm"
                                          >
                                            Ubah Agenda
                                          </button>
                                          <button
                                            onClick={() =>
                                              row.LaporanID
                                                ? bukaDetail(row)
                                                : getSpecPerjalananDinas(row.PerjalananDinasID)
                                                    .then((d) => setLaporanForm({ show: true, pd: d || row, laporan: null }))
                                                    .catch(() => setLaporanForm({ show: true, pd: row, laporan: null }))
                                            }
                                            className="bg-white hover:bg-green-50 text-green-700 font-semibold py-1 px-3 border border-green-300 rounded shadow text-sm"
                                          >
                                            Pertanggungjawaban
                                          </button>
                                        </>
                                      )}
                                      <button
                                        onClick={() => bukaDetail(row)}
                                        className="bg-white hover:bg-blue-50 text-blue-600 font-semibold py-1 px-3 border border-blue-300 rounded shadow text-sm"
                                      >
                                        Detail
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{rows.length} data</span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPage((p) => Math.max(1, p - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>
                          Page {safePage} / {totalPage}
                        </span>
                        <button
                          onClick={() => setPage((p) => Math.min(totalPage, p + 1))}
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* ── Modal Tambah/Edit ── */}
      <Modal size="lg" active={showForm} toggler={() => setShowForm(true)}>
        <ModalHeader className="mt-20" toggler={() => setShowForm(false)}>
          {form.PerjalananDinasID ? `Edit ${form.PerjalananDinasID}` : "Surat Pengajuan Perjalanan Dinas"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full" onSubmit={(e) => e.preventDefault()}>
            <div className="mb-4 rounded bg-gray-50 border px-4 py-2 text-sm text-gray-600">
              <b>SURAT PENGAJUAN PERJALANAN DINAS</b> — Nomor SPPD:{" "}
              <span className="font-mono">{form.NomorSPPD || "terbit otomatis saat pengajuan dikirim (format 12.319/RKSHO-BDM/X/2026)"}</span>
            </div>

            <KaryawanSelectorBuilder value={form.Nik} onChange={(v) => setF("Nik", v)} />
            {coba && !form.Nik && <p className="text-red-500 text-xs italic -mt-4 mb-4">Karyawan wajib dipilih</p>}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6 text-sm">
              {[
                ["Nama", identitas?.Nama],
                ["NIK", identitas?.Nik],
                ["Jabatan", identitas?.NamaJabatan],
                ["Departemen", identitas?.NamaBagian],
              ].map(([l, v]) => (
                <div key={l}>
                  <div className={LABEL}>{l}</div>
                  <div className="text-gray-800 border-b py-1">{v || "-"}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                <label className={LABEL}>Jenis Dinas *</label>
                <select value={form.Kategori} onChange={(e) => setF("Kategori", e.target.value)} className={INPUT}>
                  <option value="Penugasan">Dinas Penugasan (uang saku, Surat Tugas)</option>
                  <option value="Jabatan">Dinas Jabatan (tanpa uang saku)</option>
                </select>
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label className={LABEL}>Kota Tujuan *</label>
                <input
                  value={form.Tujuan}
                  onChange={(e) => setF("Tujuan", e.target.value)}
                  type="text"
                  maxLength={255}
                  className={coba && !form.Tujuan.trim() ? INPUT.replace("border-gray-200", "border-red-500") : INPUT}
                />
                {coba && !form.Tujuan.trim() && <p className="text-red-500 text-xs italic">Kota tujuan wajib diisi</p>}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                <label className={LABEL}>Tanggal Berangkat *</label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={tglMulai || null}
                  onChange={(d) => {
                    setTglMulai(d);
                    if (d && tglSelesai && tglSelesai < d) setTglSelesai(d);
                  }}
                  className={INPUT}
                />
                {coba && !tglMulai && <p className="text-red-500 text-xs italic">Tanggal berangkat wajib diisi</p>}
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label className={LABEL}>Tanggal Kembali *</label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={tglSelesai || null}
                  minDate={tglMulai || null}
                  onChange={(d) => setTglSelesai(d)}
                  className={INPUT}
                />
                {coba && !tglSelesai && <p className="text-red-500 text-xs italic">Tanggal kembali wajib diisi</p>}
                {salahTanggal && <p className="text-red-500 text-xs italic">Tidak boleh sebelum tanggal berangkat</p>}
              </div>
            </div>
            <div className="mb-6 text-sm">
              <span className="text-gray-700 font-semibold">Jumlah Hari: {hari > 0 ? `${hari} hari` : "-"}. </span>
              {kurangDariH3(tglMulai) && (
                <span className="text-amber-600 font-semibold">
                  ⚠ Kurang dari H-3 — pengajuan akan ditandai terlambat (tetap bisa dikirim).
                </span>
              )}
              {form.Kategori === "Penugasan" && (
                <div className="text-gray-500 mt-1">
                  Uang saku dihitung otomatis saat disimpan: tarif jabatan karyawan (Master Tarif Uang Saku) x jumlah hari.
                </div>
              )}
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className={LABEL}>Keperluan Dinas *</label>
                <textarea
                  value={form.Keperluan}
                  onChange={(e) => setF("Keperluan", e.target.value)}
                  rows={3}
                  className={coba && !form.Keperluan.trim() ? INPUT.replace("border-gray-200", "border-red-500") : INPUT}
                />
                {coba && !form.Keperluan.trim() && <p className="text-red-500 text-xs italic">Keperluan dinas wajib diisi</p>}
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className={LABEL}>Keterangan</label>
                <textarea value={form.Keterangan} onChange={(e) => setF("Keterangan", e.target.value)} rows={2} className={INPUT} />
              </div>
            </div>

            <div className="mb-2 font-semibold text-gray-700 text-sm">Rincian Tugas Perjalanan Dinas *</div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm mb-2" style={{ minWidth: 640 }}>
                <thead className="text-xs uppercase text-gray-500">
                  <tr>
                    <th className="text-left px-1 pb-1">Tanggal</th>
                    <th className="text-left px-1 pb-1">Waktu</th>
                    <th className="text-left px-1 pb-1">Kegiatan</th>
                    <th className="text-left px-1 pb-1">Lokasi</th>
                    <th className="text-left px-1 pb-1">Keterangan</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {rincian.map((r, i) => (
                    <tr key={i}>
                      <td className="px-1 py-1" style={{ width: 130 }}>
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={dariYmd(r.Tanggal) || null}
                          minDate={tglMulai || null}
                          maxDate={tglSelesai || null}
                          onChange={(d) => setR(i, "Tanggal", ymd(d))}
                          className={INPUT + " py-2"}
                        />
                      </td>
                      <td className="px-1 py-1" style={{ width: 200 }}>
                        <RentangWaktu value={r.Waktu} onChange={(v) => setR(i, "Waktu", v)} />
                      </td>
                      <td className="px-1 py-1">
                        <input value={r.Kegiatan} onChange={(e) => setR(i, "Kegiatan", e.target.value)} className={INPUT + " py-2"} />
                      </td>
                      <td className="px-1 py-1">
                        <input value={r.Lokasi} maxLength={255} onChange={(e) => setR(i, "Lokasi", e.target.value)} className={INPUT + " py-2"} />
                      </td>
                      <td className="px-1 py-1">
                        <input value={r.Keterangan} onChange={(e) => setR(i, "Keterangan", e.target.value)} className={INPUT + " py-2"} />
                      </td>
                      <td className="px-1 py-1">
                        <button
                          type="button"
                          onClick={() => setRincian((l) => (l.length > 1 ? l.filter((_, j) => j !== i) : [{ ...BARIS_RINCIAN }]))}
                          className="text-red-600 px-2 py-1 hover:bg-red-50 rounded"
                          title="Hapus baris"
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button type="button" onClick={() => setRincian((l) => [...l, { ...BARIS_RINCIAN }])} className="text-blue-600 text-sm font-semibold hover:underline">
              + Tambah baris
            </button>
            {coba && rincianTerisi.length === 0 && <p className="text-red-500 text-xs italic">Isi minimal satu baris rincian tugas</p>}
            {coba && rincianTerisi.some((r) => !r.Tanggal || !r.Kegiatan.trim()) && (
              <p className="text-red-500 text-xs italic">Setiap baris rincian wajib punya tanggal dan kegiatan</p>
            )}
            <p className="text-gray-500 text-xs mt-3">
              Alur approval: Pengaju → Head Dept → Head HR → Direktur. Estimasi biaya diisi pada Form Biaya setelah pengajuan disetujui.
            </p>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="red" buttonType="link" onClick={() => setShowForm(false)} ripple="dark">
            Batal
          </Button>
          <Button color="green" onClick={simpan} ripple="light" disabled={saving}>
            {saving ? "MENYIMPAN…" : "SIMPAN"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal Detail ── */}
      <Modal size="lg" active={showDetail} toggler={() => setShowDetail(true)}>
        <ModalHeader className="mt-20" toggler={() => setShowDetail(false)}>
          Detail Perjalanan Dinas
        </ModalHeader>
        <ModalBody>
          {detail ? (
            <>
              <DetailPerjalananDinas d={detail} />
              <Fase2Detail
                d={detail}
                lihatUbah={lihatUbah}
                setLihatUbah={setLihatUbah}
                onEditUbah={(u) => setUbahForm({ show: true, pd: detail, ubah: u })}
                onKirim={kirimDokumen}
                onHapusUbah={async (u) => {
                  if (!window.confirm(`Hapus perubahan ${u.UbahID}?`)) return;
                  try {
                    await deleteUbah(u.UbahID);
                    toast.success("Perubahan dihapus", { position: "bottom-right", autoClose: 3000 });
                    bukaDetail(detail);
                    muat(search);
                  } catch (e) {
                    toast.error(e.message, { position: "bottom-right" });
                  }
                }}
                onProsesUlang={async (jenis, id) => {
                  try {
                    const r = await prosesUlangFinance(jenis, id);
                    toast.success(r?.message || "Diproses", { position: "bottom-right", autoClose: 4000 });
                  } catch (e) {
                    toast.error(e.message, { position: "bottom-right" });
                  }
                  bukaDetail(detail);
                  muat(search);
                }}
                onBuatLaporan={() => setLaporanForm({ show: true, pd: detail, laporan: null })}
                onEditLaporan={(l) => setLaporanForm({ show: true, pd: detail, laporan: l })}
                onHapusLaporan={async (l) => {
                  if (!window.confirm(`Hapus laporan ${l.LaporanID}?`)) return;
                  try {
                    await deleteLaporan(l.LaporanID);
                    toast.success("Laporan dihapus", { position: "bottom-right", autoClose: 3000 });
                    bukaDetail(detail);
                    muat(search);
                  } catch (e) {
                    toast.error(e.message, { position: "bottom-right" });
                  }
                }}
                onSettlement={async (l) => {
                  const catatan = window.prompt("Catatan penyelesaian (mis. nomor transfer / tanggal pembayaran):", "");
                  if (catatan === null) return;
                  try {
                    await selesaikanSettlement(l.LaporanID, catatan);
                    toast.success("Settlement diselesaikan", { position: "bottom-right", autoClose: 3000 });
                    bukaDetail(detail);
                    muat(search);
                  } catch (e) {
                    toast.error(e.message, { position: "bottom-right" });
                  }
                }}
              />
            </>
          ) : (
            <div className="flex justify-center py-8">
              <Loading />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          {detail && (
            <Button color="blue" buttonType="link" onClick={() => cetakSuratPengajuan(detail).catch((e) => toast.error("Gagal mencetak: " + e.message, { position: "bottom-right" }))} ripple="dark">
              Cetak Surat Pengajuan
            </Button>
          )}
          {detail && String(detail.Status) === "99" && detail.Kategori === "Penugasan" && (
            <Button color="green" onClick={() => cetakSuratTugas(detail).catch((e) => toast.error("Gagal mencetak: " + e.message, { position: "bottom-right" }))} ripple="light">
              Cetak Surat Tugas
            </Button>
          )}
          {detail && detail.BiayaDiajukan && (
            <Button color="green" buttonType="link" onClick={() => cetakFormBiaya(detail).catch((e) => toast.error("Gagal mencetak: " + e.message, { position: "bottom-right" }))} ripple="dark">
              Cetak Form Biaya
            </Button>
          )}
          {detail && detail.Laporan && (
            <Button
              color="green"
              buttonType="link"
              onClick={() => cetakPertanggungjawaban(detail.Laporan).catch((e) => toast.error("Gagal mencetak: " + e.message, { position: "bottom-right" }))}
              ripple="dark"
            >
              Cetak Form Pertanggungjawaban
            </Button>
          )}
          {detail && String(detail.Status) === "99" && !detail.BiayaDiajukan && !detail.LaporanID && (
            <Button color="blue" onClick={() => setFormBiaya({ show: true, pd: detail })} ripple="light">
              Isi Form Biaya
            </Button>
          )}
          <Button color="blueGray" buttonType="link" onClick={() => setShowDetail(false)} ripple="dark">
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      <FormBiayaModal
        show={formBiaya.show}
        pd={formBiaya.pd}
        onClose={() => setFormBiaya({ show: false, pd: null })}
        onSaved={() => {
          const pd = formBiaya.pd;
          setFormBiaya({ show: false, pd: null });
          muat(search);
          if (showDetail) bukaDetail(pd);
        }}
      />
      <UbahModal
        show={ubahForm.show}
        pd={ubahForm.pd}
        ubah={ubahForm.ubah}
        onClose={() => setUbahForm({ show: false, pd: null, ubah: null })}
        onSaved={() => {
          const pd = ubahForm.pd;
          setUbahForm({ show: false, pd: null, ubah: null });
          muat(search);
          bukaDetail(pd);
        }}
      />
      <LaporanModal
        show={laporanForm.show}
        pd={laporanForm.pd}
        laporan={laporanForm.laporan}
        onClose={() => setLaporanForm({ show: false, pd: null, laporan: null })}
        onSaved={() => {
          const pd = laporanForm.pd;
          setLaporanForm({ show: false, pd: null, laporan: null });
          muat(search);
          bukaDetail(pd);
        }}
      />
    </>
  );
};

// Rentang waktu "HH:MM-HH:MM": dua pilihan jam (dari – sampai), disimpan sebagai satu teks.
const RentangWaktu = ({ value, onChange }) => {
  const [dari = "", sampai = ""] = (value || "").split("-");
  const kecil = INPUT + " py-2 px-2";
  return (
    <div className="flex items-center gap-1">
      <input type="time" value={dari} onChange={(e) => onChange(e.target.value || sampai ? `${e.target.value}-${sampai}` : "")} className={kecil} />
      <span>–</span>
      <input type="time" value={sampai} min={dari || undefined} onChange={(e) => onChange(dari || e.target.value ? `${dari}-${e.target.value}` : "")} className={kecil} />
    </div>
  );
};

// Form Biaya (tahap kedua, setelah Surat Pengajuan Selesai): estimasi biaya + jenis dana.
// Jenis dana Uang Muka langsung membentuk dokumen Uang Muka ke Finance.
const BARIS_KOMPONEN = (j) => ({ Jenis: j, Qty: "", Satuan: "", Harga: "", Keterangan: "" });
// Total baris = Qty × Harga Satuan (Qty kosong dianggap 1).
const totalBaris = (b) => Math.round((b.Qty === "" ? 1 : Number(b.Qty) || 0) * (Number(b.Harga) || 0) * 100) / 100;

const FormBiayaModal = ({ show, pd, onClose, onSaved }) => {
  const [jenisDana, setJenisDana] = useState("Reimbursement");
  const [baris, setBaris] = useState(JENIS_BIAYA.map(BARIS_KOMPONEN));
  const [moda, setModa] = useState([]);
  const [modaLain, setModaLain] = useState("");
  const [metode, setMetode] = useState("");
  const [metodeLain, setMetodeLain] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (show) {
      setJenisDana("Reimbursement");
      setBaris(JENIS_BIAYA.map(BARIS_KOMPONEN));
      setModa([]);
      setModaLain("");
      setMetode("");
      setMetodeLain("");
    }
  }, [show]);
  if (!pd) return null;
  const sakuPenugasan = pd.Kategori === "Penugasan" ? Number(pd.EstimasiUangSaku || 0) : 0;
  const total = baris.reduce((s, b) => s + totalBaris(b), 0);
  const setB = (i, k, v) => setBaris((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const angka = (v) => v.replace(/[^0-9.]/g, "");
  const simpanBiaya = async () => {
    const isi = baris
      .filter((b) => totalBaris(b) || b.Keterangan.trim())
      .map((b) => ({
        Jenis: b.Jenis,
        Qty: Number(b.Qty) || 0,
        Satuan: b.Satuan.trim(),
        Keterangan: b.Keterangan.trim(),
        Nominal: totalBaris(b),
      }));
    if (jenisDana === "UangMuka" && total + sakuPenugasan <= 0) {
      toast.error("Pengajuan Uang Muka wajib mengisi komponen biaya.", { position: "bottom-right" });
      return;
    }
    if (!window.confirm("Form Biaya tidak dapat diubah lagi setelah diajukan" + (jenisDana === "UangMuka" ? " dan dokumen Uang Muka akan dikirim ke Finance" : "") + ". Lanjutkan?")) return;
    setSaving(true);
    try {
      await simpanFormBiaya({
        PerjalananDinasID: pd.PerjalananDinasID,
        JenisDana: jenisDana,
        Biaya: isi,
        ModaTransportasi: moda,
        ModaLainnya: moda.includes("Lainnya") ? modaLain : "",
        MetodePembayaran: metode,
        MetodeLainnya: metode === "Lainnya" ? metodeLain : "",
      });
      toast.success("Form Biaya diajukan", { position: "bottom-right", autoClose: 3000 });
      onSaved();
    } catch (e) {
      toast.error(e.message, { position: "bottom-right", autoClose: 8000 });
      if (String(e.message).includes("tersimpan")) onSaved(); // Form Biaya masuk, hanya Uang Muka yang gagal
    }
    setSaving(false);
  };
  const cell = INPUT + " py-2 px-2";
  return (
    <Modal size="lg" active={show} toggler={() => {}}>
      <ModalHeader className="mt-20" toggler={onClose}>
        Form Biaya Perjalanan Dinas — {pd.NomorSPPD || pd.PerjalananDinasID}
      </ModalHeader>
      <ModalBody>
        <div className="mb-4 text-sm text-gray-600 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1">
          <div>No. Surat Tugas: <b>{pd.NomorSurat || "-"}</b></div>
          <div>Jumlah Hari: <b>{pd.JumlahHari} hari</b></div>
          <div>Kota Tujuan: <b>{pd.Tujuan}</b></div>
          <div>Jumlah Personel: <b>1</b> ({pd.NamaKaryawan})</div>
          <div>Tanggal: <b>{tglIndo(pd.TanggalMulai)} s/d {tglIndo(pd.TanggalSelesai)}</b></div>
          <div>Jenis Dinas: <b>{pd.Kategori === "Penugasan" ? "Dinas Penugasan" : "Dinas Jabatan"}</b></div>
        </div>

        <label className={LABEL}>Transportasi</label>
        <div className="flex flex-wrap gap-x-4 gap-y-1 mb-1 text-sm">
          {MODA_TRANSPORTASI.map((m) => (
            <label key={m} className="flex items-center gap-1">
              <input
                type="checkbox"
                checked={moda.includes(m)}
                onChange={(e) => setModa((l) => (e.target.checked ? [...l, m] : l.filter((x) => x !== m)))}
              />
              {m}
            </label>
          ))}
        </div>
        {moda.includes("Lainnya") && (
          <input value={modaLain} maxLength={100} placeholder="Moda lainnya" onChange={(e) => setModaLain(e.target.value)} className={cell + " mb-2"} />
        )}

        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm" style={{ minWidth: 740 }}>
            <thead className="text-xs uppercase text-gray-500">
              <tr>
                <th className="text-left px-1 pb-1">Komponen Biaya</th>
                <th className="text-left px-1 pb-1" style={{ width: 70 }}>Qty</th>
                <th className="text-left px-1 pb-1" style={{ width: 90 }}>Satuan</th>
                <th className="text-left px-1 pb-1" style={{ width: 120 }}>Harga Satuan</th>
                <th className="text-left px-1 pb-1" style={{ width: 120 }}>Total</th>
                <th className="text-left px-1 pb-1">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {baris.map((b, i) => (
                <tr key={b.Jenis}>
                  <td className="px-1 py-1 whitespace-nowrap">{b.Jenis}</td>
                  <td className="px-1 py-1"><input value={b.Qty} inputMode="decimal" onChange={(e) => setB(i, "Qty", angka(e.target.value))} className={cell + " text-right"} /></td>
                  <td className="px-1 py-1"><input value={b.Satuan} maxLength={30} onChange={(e) => setB(i, "Satuan", e.target.value)} className={cell} /></td>
                  <td className="px-1 py-1"><input value={b.Harga} inputMode="decimal" onChange={(e) => setB(i, "Harga", angka(e.target.value))} className={cell + " text-right"} /></td>
                  <td className="px-1 py-1 text-right bg-gray-50">{rupiah(totalBaris(b))}</td>
                  <td className="px-1 py-1"><input value={b.Keterangan} maxLength={255} onChange={(e) => setB(i, "Keterangan", e.target.value)} className={cell} /></td>
                </tr>
              ))}
              {pd.Kategori === "Penugasan" && (
                <tr className="bg-gray-50">
                  <td className="px-1 py-1 whitespace-nowrap">Uang Saku</td>
                  <td className="px-1 py-1 text-right">{pd.JumlahHari}</td>
                  <td className="px-1 py-1">hari</td>
                  <td className="px-1 py-1 text-right text-gray-500">{pd.JumlahHari ? rupiah(sakuPenugasan / pd.JumlahHari) : "-"}</td>
                  <td className="px-1 py-1 text-right">{rupiah(sakuPenugasan)}</td>
                  <td className="px-1 py-1 text-gray-500">otomatis dari tarif jabatan</td>
                </tr>
              )}
              <tr className="border-t font-semibold">
                <td className="px-1 py-2" colSpan={4}>Jumlah</td>
                <td className="px-1 py-2 text-right">{rupiah(total + sakuPenugasan)}</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>

        <label className={LABEL + " mt-4"}>Pendanaan *</label>
        <select value={jenisDana} onChange={(e) => setJenisDana(e.target.value)} className={INPUT + " mb-4"}>
          <option value="Reimbursement">Reimbursement (dana pribadi dulu)</option>
          <option value="UangMuka">Uang Muka (advance) — nominal = jumlah di atas, dikirim ke Finance</option>
        </select>

        <label className={LABEL}>Metode Pembayaran</label>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
          {METODE_PEMBAYARAN.map(([v, l]) => (
            <label key={v} className="flex items-center gap-1">
              <input type="radio" name="metode" checked={metode === v} onChange={() => setMetode(v)} />
              {l}
            </label>
          ))}
        </div>
        {metode === "Lainnya" && (
          <input value={metodeLain} maxLength={100} placeholder="Metode lainnya" onChange={(e) => setMetodeLain(e.target.value)} className={cell + " mt-2"} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="red" buttonType="link" onClick={onClose} ripple="dark">
          Batal
        </Button>
        <Button color="green" onClick={simpanBiaya} ripple="light" disabled={saving}>
          {saving ? "MENGAJUKAN…" : "AJUKAN FORM BIAYA"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// Bagian Fase 2 di modal Detail: riwayat perubahan agenda + laporan (LPD) dengan aksinya.
const Fase2Detail = ({
  d,
  lihatUbah,
  setLihatUbah,
  onEditUbah,
  onKirim,
  onHapusUbah,
  onProsesUlang,
  onBuatLaporan,
  onEditLaporan,
  onHapusLaporan,
  onSettlement,
}) => {
  if (String(d.Status) !== "99") return null;
  const bisaEdit = (st) => ["-1", "-2", "-3"].includes(String(st));
  const lap = d.Laporan;
  const btn = "font-semibold py-1 px-3 border rounded shadow text-sm bg-white ";
  return (
    <>
      {d.JenisDana === "UangMuka" && (
        <div className="border rounded p-3 text-sm mt-4">
          <div className="font-semibold text-gray-700 mb-1">Uang Muka di Finance</div>
          {d.UangMukaCashJournalID && d.UangMukaCashJournalID !== "(proses)" ? (
            <div>
              Dokumen <b>{d.UangMukaCashJournalID}</b> — {d.UangMukaStatusKet}
            </div>
          ) : (
            <div className="text-amber-700">
              Dokumen uang muka belum terbentuk.{" "}
              <button type="button" className="underline font-semibold" onClick={() => onProsesUlang("UangMuka", d.PerjalananDinasID)}>
                Proses ulang Finance
              </button>
            </div>
          )}
        </div>
      )}
      <div className="border-t mt-4 pt-3 mb-2 font-semibold text-gray-700">Perubahan Agenda</div>
      {(d.Ubah || []).length === 0 ? (
        <div className="text-gray-400 text-sm">Belum ada perubahan agenda.</div>
      ) : (
        <div className="space-y-2">
          {d.Ubah.map((u) => (
            <div key={u.UbahID} className="border rounded px-4 py-2 text-sm">
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span>
                  <b>{u.UbahID}</b> — {u.TujuanBaru}, {tglIndo(u.TanggalMulaiBaru)} s/d {tglIndo(u.TanggalSelesaiBaru)}
                </span>
                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(u.StatusKet)}`}>{u.StatusKet}</span>
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                <button className={btn + "text-blue-600 border-blue-300"} onClick={() => setLihatUbah(lihatUbah === u.UbahID ? "" : u.UbahID)}>
                  {lihatUbah === u.UbahID ? "Tutup" : "Lihat"}
                </button>
                {bisaEdit(u.Status) && (
                  <>
                    <button className={btn + "text-gray-800 border-gray-400"} onClick={() => onEditUbah(u)}>Edit</button>
                    <button className={btn.replace("bg-white", "bg-blue-500 text-white border-blue-500")} onClick={() => onKirim(u.UbahID)}>Kirim</button>
                  </>
                )}
                {String(u.Status) === "-1" && (
                  <button className={btn + "text-red-600 border-red-300"} onClick={() => onHapusUbah(u)}>Hapus</button>
                )}
              </div>
              {lihatUbah === u.UbahID && (
                <div className="mt-3 border-t pt-3">
                  <DetailUbah u={u} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="border-t mt-4 pt-3 mb-2 font-semibold text-gray-700 flex items-center justify-between">
        <span>Form Pertanggungjawaban Perjalanan Dinas (LPD)</span>
        <span className={d.LPDOutstanding && d.SisaHariLPD < 0 ? "text-red-600 text-sm" : "text-gray-500 text-sm"}>
          Batas {tglIndo(d.BatasLPD)}
          {d.LPDOutstanding && <> · {teksSisaLPD(d)}</>}
        </span>
      </div>
      {!lap ? (
        <button className={btn + "text-green-700 border-green-300"} onClick={onBuatLaporan}>
          Buat Pertanggungjawaban
        </button>
      ) : (
        <div className="border rounded px-4 py-3">
          <div className="flex gap-2 mb-3 flex-wrap">
            {bisaEdit(lap.Status) && (
              <>
                <button className={btn + "text-gray-800 border-gray-400"} onClick={() => onEditLaporan(lap)}>Edit</button>
                <button className={btn.replace("bg-white", "bg-blue-500 text-white border-blue-500")} onClick={() => onKirim(lap.LaporanID)}>Kirim</button>
              </>
            )}
            {String(lap.Status) === "-1" && (
              <button className={btn + "text-red-600 border-red-300"} onClick={() => onHapusLaporan(lap)}>Hapus</button>
            )}
            {String(lap.Status) === "99" && lap.SettlementStatus === "Menunggu" && !lap.SelisihCashJournalID && (
              <button className={btn.replace("bg-white", "bg-green-600 text-white border-green-600")} onClick={() => onSettlement(lap)}>
                Selesaikan Settlement
              </button>
            )}
          </div>
          <DetailLaporan l={lap} onProsesUlang={(l) => onProsesUlang("Laporan", l.LaporanID)} />
        </div>
      )}
    </>
  );
};

// Ringkasan read-only: dipakai di modal Detail halaman ini dan modal Daftar Approval.
export const DetailPerjalananDinas = ({ d }) => {
  const item = (label, isi, span2) => (
    <div className={span2 ? "sm:col-span-2" : ""}>
      <div className="text-xs font-bold uppercase text-gray-500">{label}</div>
      <div className="text-gray-800 whitespace-pre-line">{isi || "-"}</div>
    </div>
  );
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
        {item("Nomor SPPD", d.NomorSPPD || "(terbit saat dikirim)")}
        {item("ID", d.PerjalananDinasID)}
        {item("Status", d.StatusKet)}
        {item("Karyawan", `${d.NamaKaryawan} (${d.Nik})`)}
        {item("Jabatan / Bagian", `${d.NamaJabatan || "-"} / ${d.NamaBagian || "-"}`)}
        {item("Jenis Dinas", d.Kategori === "Penugasan" ? "Dinas Penugasan" : "Dinas Jabatan")}
        {item("Kota Tujuan", d.Tujuan)}
        {item("Tanggal Berangkat", tglIndo(d.TanggalMulai))}
        {item("Tanggal Kembali", `${tglIndo(d.TanggalSelesai)} (${d.JumlahHari} hari)`)}
        {d.LihatDana && d.BiayaDiajukan && item("Pendanaan", d.JenisDana === "UangMuka" ? "Uang Muka" : "Reimbursement")}
        {d.LihatDana && d.BiayaDiajukan && item("Estimasi Biaya", rupiah(d.EstimasiBiaya))}
        {d.BiayaDiajukan && (d.ModaTransportasi || []).length > 0 &&
          item("Transportasi", d.ModaTransportasi.map((m) => (m === "Lainnya" && d.ModaLainnya ? `Lainnya (${d.ModaLainnya})` : m)).join(", "))}
        {d.BiayaDiajukan && d.MetodePembayaran &&
          item("Metode Pembayaran", d.MetodePembayaran === "Lainnya" && d.MetodeLainnya ? `Lainnya (${d.MetodeLainnya})` : (METODE_PEMBAYARAN.find(([v]) => v === d.MetodePembayaran) || [0, d.MetodePembayaran])[1])}
        {d.LihatDana && d.Kategori === "Penugasan" &&
          item("Uang Saku", `${rupiah(d.TarifUangSaku)} x ${d.JumlahHari} hari = ${rupiah(d.EstimasiUangSaku)}`)}
        {d.NomorSurat && item("Nomor Surat Tugas", d.NomorSurat)}
        {item("Keperluan Dinas", d.Keperluan, true)}
        {d.Keterangan && item("Keterangan", d.Keterangan, true)}
      </div>
      {Array.isArray(d.Rincian) && d.Rincian.length > 0 && (
        <>
          <div className="border-t pt-3 mb-2 font-semibold text-gray-700">Rincian Tugas Perjalanan Dinas</div>
          <div className="overflow-x-auto mb-4">
            <table className="w-full text-sm">
              <thead className="text-xs uppercase text-gray-500">
                <tr>
                  {["Tanggal", "Waktu", "Kegiatan", "Lokasi", "Keterangan"].map((h) => (
                    <th key={h} className="text-left py-1 pr-2">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {d.Rincian.map((r, i) => (
                  <tr key={i} className="border-b">
                    <td className="py-1 pr-2 whitespace-nowrap">{tglIndo(r.Tanggal)}</td>
                    <td className="py-1 pr-2">{r.Waktu || "-"}</td>
                    <td className="py-1 pr-2">{r.Kegiatan}</td>
                    <td className="py-1 pr-2">{r.Lokasi || "-"}</td>
                    <td className="py-1 text-gray-500">{r.Keterangan}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {d.TerlambatH3 && (
        <div className="mb-3 text-sm font-semibold text-amber-600">⚠ Diajukan kurang dari H-3 sebelum keberangkatan.</div>
      )}
      {d.LihatDana && d.Kategori === "Penugasan" && Number(d.TarifUangSaku) === 0 && (
        <div className="mb-3 text-sm text-amber-600">Tarif uang saku jabatan ini belum diisi di Master Tarif Uang Saku.</div>
      )}

      {d.LihatDana && Array.isArray(d.Biaya) && d.Biaya.length > 0 && (
        <>
          <div className="border-t pt-3 mb-2 font-semibold text-gray-700">Form Biaya — Rincian Estimasi</div>
          <table className="w-full text-sm mb-4">
            <tbody>
              {d.Biaya.map((b, i) => (
                <tr key={i} className="border-b">
                  <td className="py-1 pr-2 w-40">{b.Jenis}</td>
                  <td className="py-1 pr-2 text-gray-500">
                    {b.Qty ? `${b.Qty} ${b.Satuan || ""} ` : ""}
                    {b.Keterangan}
                  </td>
                  <td className="py-1 text-right">{rupiah(b.Nominal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <div className="border-t pt-3 mb-2 font-semibold text-gray-700">Alur Approval Pengajuan</div>
      {Array.isArray(d.ApprovalList) && d.ApprovalList.length > 0 ? (
        <div className="space-y-2">
          {d.ApprovalList.map((a, i) => (
            <div key={i} className="border rounded px-4 py-2 flex items-center justify-between gap-2 text-sm">
              <span className="font-medium text-gray-800">
                {a.Urutan ? `${a.Urutan}. ` : ""}
                {a.Nama}
              </span>
              <span className="text-gray-500 text-xs text-right">
                {a.Keterangan} {a.Status}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-400 text-sm">-</div>
      )}
    </div>
  );
};

export default PerjalananDinasPage;
